import React from 'react'
import { useCookies } from 'react-cookie'
import { Route } from 'react-router-dom'

import { SideMenuLayout } from '../components/SideMenuLayout/SideMenuLayout'
import { authTokenCookieName } from '../util/cookies'
import { getSignInUrl } from '../util/auth'

export const PrivateRoute = ({ component: ProtectedComponent, ...rest }: any) => {
  const [cookies] = useCookies()
  const isLoggedIn = !!cookies[authTokenCookieName]

  if (!isLoggedIn) {
    window.location.href = getSignInUrl()
    return null
  }

  const renderComponent = (props: any) => (
    <SideMenuLayout>
      <ProtectedComponent {...props} />
    </SideMenuLayout>
  )

  return <Route {...rest} render={(props) => renderComponent({ ...props, rest })} />
}
